<div [style.display]="isVisible() ? 'flex' : 'none'" class="barcode-wrapper" [id]="htmlId()">
  <div class="barcode-controls">
    <button type="button" role="button" class="barcode-scan-button" [disabled]="isReadonly() || formControl?.disabled"
            (click)="onScanClick($event)">
      <div class="icon-safe-zone">
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="currentColor"><path d="M40-120v-200h80v120h120v80H40Zm680 0v-80h120v-120h80v200H720ZM160-240v-480h80v480h-80Zm120 0v-480h40v480h-40Zm120 0v-480h80v480h-80Zm120 0v-480h120v480H520Zm160 0v-480h40v480h-40Zm80 0v-480h40v480h-40ZM40-640v-200h200v80H120v120H40Zm800 0v-120H720v-80h200v200h-80Z"/></svg>
      </div>
      <span [ngClass]="[properties.style.toLowerCase(), 'no-style-background']">{{ this.properties.text }}</span>
    </button>
  </div>

  @if (properties.resultValue) {
    @if (isShowMode()) {
      <div class="barcode-result">
        <div class="barcode-scanned-display">
          {{ translateService.instant('liveforms-editor.barcode-item.result.scanned-barcode', { barcode: properties.detectedBarcode }) }}
        </div>
      </div>
    }

    @if (isCompareMode()) {
      <div class="barcode-comparison-result">
        <div class="scanned-barcode" [class.match]="properties.barcodeMatches === 'True'" [class.no-match]="properties.barcodeMatches === 'False'">
          @if (properties.barcodeMatches === 'True') {
            <span class="barcode-scanned-display">{{ translateService.instant('liveforms-editor.barcode-item.result.expected-match', { barcode: properties.expectedBarcode }) }}</span>
          } @else {
            <span class="barcode-scanned-display">{{ translateService.instant('liveforms-editor.barcode-item.result.expected-no-match', { barcode: properties.expectedBarcode }) }}</span>
          }
        </div>
      </div>
    }
  }

</div>
